<template>
  <ul class="nav nav-stacked">
    <departments-dropdown-item
        v-for="department in departments"
        :key="department.id"
        :department="department" ></departments-dropdown-item>
    <li><router-link style="color: #ffffff" :to="{name: 'about'}">About</router-link></li>
  </ul>
</template>
<script>
  import DepartmentMenuItem from "../../admin/departments/department-menu-item";
  import DepartmentsDropdownItem from "./departments-dropdown-item";
  export default {
    name: 'departments-dropdown',
    components: { DepartmentsDropdownItem, DepartmentMenuItem },
    data() {
      return {}
    },

    computed: {
      departments() {
        return this.$store.getters.departments;
      }
    }
  }
</script>